import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card'
import Chip from '@mui/material/Chip'
import { DataGrid } from '@mui/x-data-grid';

import { placeBid, fetchPendingJobOffers } from './action';
import { selectPendingJobOffers, selectUpdateJobError } from './selector';
import { selectUser } from '../Auth/selector';

const JobOfferList = () => {
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(selectUser);
  const pendingJobOffers = useSelector(selectPendingJobOffers);
  const updateJobError = useSelector(selectUpdateJobError);

  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    dispatch(fetchPendingJobOffers());
  }, [dispatch]);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const onPlaceBid = (row) => {
    setSelectedJob(row);
  };

  const handleCloseDialog = () => {
    setSelectedJob(null);
  };

  const handleCancelJob = () => {
    dispatch(placeBid(selectedJob));
    setSelectedJob(null);
  };

  const columns = [
    { field: '_id', sortable: false, headerName: 'Job ID', width: 220 },
    { field: 'creatorId', headerName: 'Owner ID', width: 220 },
    {
      field: 'createdAt',
      headerName: 'Created on',
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString('en-US');
      }
    },
    {
      field: 'petName',
      headerName: 'Pet Name',
      width: 150,
      valueGetter: (params) => params.row.jobDetails.petName,
    },
    {
      field: 'petType',
      headerName: 'Pet Type',
      width: 150,
      valueGetter: (params) => {
        const { petType } = params.row.jobDetails;
        return petTypes.find(pet => pet.value === petType)?.label;
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      isableClickEventBubbling: true,
      sortable: false,
      renderCell: (params) => (
        params.row.sitterBids.includes(authenticatedUser._id) ? (
          <Button variant="text" disabled>Bid Placed</Button>
        ) : (
          <Chip variant="outlined" onClick={() => onPlaceBid(params.row)} label={'Place Bid'}/>
             
           
          // <Button >
          //  
          // </Button>
        )
      ),
    },
  ];

  return (
    <Container component="main" maxWidth="lg" sx={{ pt: 6 }}>
       <Card sx={{ padding: "2rem" }}>
      <Dialog
        maxWidth="xs"
        open={selectedJob !== null}
      >
        <DialogTitle sx={{ pb: 3.5 }}>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to bid for this job?
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button autoFocus onClick={handleCloseDialog}>No</Button>
          <Button onClick={handleCancelJob}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Typography variant="h5" component="h1">
        Total Job Offers Available: {pendingJobOffers.length}
      </Typography>
      {updateJobError && (
        <Alert severity="error" sx={{ mt: 1 }}>{updateJobError}</Alert>
      )}
      <div
        style={{
          height: 80 * pendingJobOffers.length + 200,
          width: '100%',
          marginTop: 20,
        }}
      >
        <DataGrid
          rows={pendingJobOffers}
          columns={columns}
          getRowId={row => row._id}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </div>
      </Card>
    </Container>
  );
};

export default JobOfferList;
